import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueRouter from 'vue-router'
import store from './store/store'
import {routers} from './router'
import axios from 'axios'
import swal from 'sweetalert2'
import User from "./apis/user";
import Flutterwave from  'flutterwave-vue-v3'
import vmodal from 'vue-js-modal'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.prototype.$http = axios
window.Swal = swal;


Vue.use(BootstrapVue)
Vue.use(VueRouter);

Vue.use(Flutterwave, { publicKey: 'FLWPUBK-42d43cc1690dde68de50682c3a3c21e7-X' } )
Vue.use(vmodal , { dialog: true })

let router = new VueRouter({
  mode: 'history', 
  routes: routers,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

new Vue({
  router,
  store,
  beforeCreate() { 
    this.$store.commit('auth/initializeUserData', null);
  },
  render: h => h(App),
	created () {
		if(this.$store.state.auth.userData != null)
		{
			this.getStatus()
		}
  },
  mounted()
  {
    // import('./events/notification').then(m => {
    // })
  },
	methods: {
		getStatus() {
			var that = this

			User.user()
				.then((response) => {
					//
				})
				.catch(function (error) {
					let message = error.response.data.message
					if(message == "Unauthenticated.") {							
						that.$store.commit('auth/removeUserInfo', null);
						that.$router.push({ path: "/login" })
					}
				});
		}
  },
}).$mount('#app')
